import i18n from 'app/locales/i18n';

export const PasswordValidationRules = [
  { min: 8, message: i18n.t('errorPasswordMin') },
  {
    required: true,
    message: i18n.t('errorRequiredDefault')
  },
  {
    pattern: new RegExp(/[A-Z]/g),
    message: i18n.t('errorPasswordUppercase')
  },
  {
    pattern: new RegExp(/[a-z]/g),
    message: i18n.t('errorPasswordLowercase')
  },
  {
    pattern: new RegExp(/[0-9]/g),
    message: i18n.t('errorPasswordNumbers')
  }
];

export const EmailValidationRules = [
  {
    type: 'email',
    message: i18n.t('errorEmailNotEmail')
  },
  {
    required: true,
    message: i18n.t('errorRequiredDefault')
  }
];
